const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  title: {
    flex: 1
  },
  tabsContainer: {
    marginBottom: theme.spacing.unit * 3
  },
  tabsIndicator: {
    backgroundColor: theme.palette.primary.main
  },
  tabsScroller: {
    '& > div': {
      borderBottom: '2px solid rgba(12,31,44,0.12)'
    }
  },
  tabRoot: {
    marginRight: theme.spacing.unit * 5,
    minWidth: 196
  },
  tabLabelContainer: {
    padding: 0
  },
  tabLabel: {
    fontWeight: '500 !important',
    textTransform: 'capitalize'
  },
  tabLabelSelected: {
    '& span span span': {
      color: `${theme.palette.primary.main} !important`
    }
  }
});

export default styles;
